import { render } from "./BetPointSettings.vue?vue&type=template&id=016a487c&scoped=true"
import script from "./BetPointSettings.vue?vue&type=script&lang=js"
export * from "./BetPointSettings.vue?vue&type=script&lang=js"

import "./BetPointSettings.vue?vue&type=style&index=0&id=016a487c&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016a487c"]])

export default __exports__